import { useCallback } from "react";
import PropTypes from "prop-types";
import { useLottie } from "lottie-react";

// lottie-react 3.1's component returns ref cleanup functions, which React 18
// warns about. Its hook lets us attach the same animation with a void ref.
export default function LottieAnimation({ src, loop = false, autoplay = false, style, ...attributes }) {
  const { setDisplayRef, setRootRef } = useLottie({ src, loop, autoplay });
  const attach = useCallback((node) => {
    setDisplayRef(node);
    setRootRef(node);
  }, [setDisplayRef, setRootRef]);

  return (
    <div
      {...attributes}
      ref={attach}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        border: 0,
        padding: 0,
        ...style,
      }}
    />
  );
}

LottieAnimation.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  loop: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  autoplay: PropTypes.bool,
  style: PropTypes.object,
};
